import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Table from "components/table/Table";
import { AddButton, SmallScreenModel } from "components";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { TableColumns } from "./components/TableColumns";
import { fetchMembershipDurationByPackageId } from "../store/action";
import HandleCreateMembershipDuration from "./manage_membership_duration/HandleCreateMembershipDuration";
import { useUser } from "utils/helpers/UserContext";
import { Authorities } from "props/authoritries";
import { SuperAdminStatusEnum } from '../../../../../props/enum';
interface OwnProp {
  package_id: string;
  tableHeaders?: string[];
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & OwnProp;

const MembershipDurationByPackageIdTable: React.FC<Props> = ({
  onFetchMembershipDuration,
  fetchMembershipDurationByPackageId,
  package_id,
  tableHeaders,
}) => {
  const { authUser, action, superAdmin } = useUser();
   const isPermitted =
        authUser &&
        (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
          action?.includes(Authorities.CREATE_COMMERCIAL_MEMBERSHIP_DURATION));
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => setModalOpen(false);
  const openModal = () => setModalOpen(true);
  useEffect(() => {
    onFetchMembershipDuration(package_id);
  }, [onFetchMembershipDuration]);
  const { isLoading, membershipDuration } = fetchMembershipDurationByPackageId;
  const currentMembershipDurations = membershipDuration;
  return (
    <div className="">
      <Table
        headers={tableHeaders? tableHeaders :["Membership Plan", "Membership Durations"]}
        data={currentMembershipDurations}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <>
           {isPermitted && (<AddButton
            onClick={openModal}
            label="Add Membership Duration"
            tooltip="Add new membership duration"
          />)}
          </>
        }
      />
      <SmallScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
         <div className="text-center">
          <HandleCreateMembershipDuration closeModal={closeModal} package_id={package_id} />
        </div>
      </SmallScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    fetchMembershipDurationByPackageId:
      state.membershipDuration?.fetchmembershipDurationState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchMembershipDuration: (package_id: string) =>
    dispatch(fetchMembershipDurationByPackageId(package_id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MembershipDurationByPackageIdTable);
